import { withInstall } from '@zoryn/utils'
import MessageCenter from './src/message-center.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZMessageCenter: SFCWithInstall<typeof MessageCenter> =
  withInstall(MessageCenter)
export default ZMessageCenter

export * from './src/message-center'
export * from './src/types'
export * from './src/constants'
export * from './src/unread'
export * from './src/utils/group-chat'
export * from './src/utils/message-api'
export * from './src/utils/message-mapper'
export * from './src/utils/message-mock'
export { useMessageList } from './src/composables/use-message-list'
export type { MessageCenterInstance } from './src/instance'
